import { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useReport } from "../../context/report";

export default function GeralColaborador() {
    const [totalPorGrupo, setTotalPorGrupo] = useState({ });
    const { data } = useReport();

    useEffect(() => {
        let _totalPorGrupo = { };

        data.dados.forEach((item) => {
            if(item.grupo in _totalPorGrupo) {
                _totalPorGrupo[item.grupo] += parseFloat(item.metragem);
            } else {
                _totalPorGrupo[item.grupo] = parseFloat(item.metragem);
            }
        }); 
        setTotalPorGrupo(_totalPorGrupo);
    }, [data]);

    return (
        <div>
            <h3 className="p-m-1 p-text-center p-p-2">Relatório Geral por Colaborador - {data.periodo}</h3>
            <DataTable
                groupRowsBy="grupo"
                rowGroupHeaderTemplate={(data) => {
                    return (
                        <div>
                            <h2 className="p-m-1 p-p-2">GRUPO {data.grupo}</h2>
                            <h2 className="p-m-1 p-p-2">Total {data.grupo in totalPorGrupo ? totalPorGrupo[data.grupo] : 0}</h2>
                        </div>
                    )
                }}
                rowGroupMode="subheader"
                responsiveLayout="scroll"
                size="small"
                value={data.dados}
            >
                <Column header="Turma" field="turma" body={(rowData) => {
                    return (
                        <div
                            style={{ backgroundColor: rowData.color, borderRadius: 4, margin: 0, padding: 12 }}
                        >
                            <p className="p-m-0 p-text-center" style={{ color: "#fff" }}>{rowData.turma}</p>
                        </div>
                    )
                }} />
                <Column header="Nome" field="colaborador"  />
                <Column header="(m)" field="metragem" />
                <Column header="%" field="percentual" body={(rowData) => (
                    <span>{Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rowData.percentual)}%</span>
                )} />
                <Column header="Média Batidas" field="batidas" />
                <Column header="Média RPM" field="rpm"  />
                <Column header="Qtde Engrupagem" field="qe" />
                <Column header="Qtde Reengrupagem" field="qr" />
            </DataTable>
        </div>
    )
}